<template>
    <footer class="bg-green-500">
        <div class="normal-container">
            <div class="max:px-0">
                <!-- Tablet (lg, 1024-1279): 5 blocks don't fit one row; pack left instead of justify-between's gaping gap. Desktop (xl+) unchanged. -->
                <div class="flex flex-wrap gap-0 py-9 lg:justify-start lg:gap-12 lg:py-20 xl:justify-between">
                    <NewsletterForm />
                    <UiFooterContact :site-config="siteConfig?.[0]" :open="openIndex === '0'" @toggle="toggle('0')" />
                    <UiFooterNavigation
                        v-for="(category, index) in filteredNavigationElements"
                        :key="category.id"
                        :category="category"
                        :open="openIndex === index"
                        @toggle="toggle(index)" />
                    <UiFooterSocials :site-config="siteConfig?.[0]" />
                </div>
                <UiFooterPayments />
                <UiFooterLegal />
            </div>
        </div>
    </footer>
</template>

<script lang="ts" setup>
    import { ref, computed } from 'vue';

    const { getUrlById } = useCategorySeoUrl();

    const props = defineProps({
        siteConfig: Object,
    });

    import { useNavigation } from '@shopware-pwa/composables-next';
    const { navigationElements, loadNavigationElements } = useNavigation({
        type: 'footer-navigation',
    });
    loadNavigationElements({
        depth: 1,
        criteria: [
            {
                type: 'equals',
                field: 'type',
                value: 'page',
            },
        ],
        associations: {
            seoUrls: {},
            children: {
                associations: {
                    seoUrls: {},
                },
            },
        },
    }).catch(() => {});

    const filteredNavigationElements = computed(() => {
        return navigationElements.value.filter(
            element => element?.translated?.name?.toLowerCase() !== 'privacy disclaimer',
        );
    });

    let openIndex = ref(-1);

    const toggle = (index: string | number) => {
        if (openIndex.value === index) {
            openIndex.value = -1;
        } else {
            openIndex.value = index;
        }
    };

    watch(filteredNavigationElements, newVal => {
        newVal.map(category => {
            category?.children.map(child => getUrlById(child.id)).filter(Boolean);
        });
    });
</script>
